/**
 * HTTP status code utilities
 */

/**
 * Checks if an HTTP status code indicates success (2xx range)
 * @param status - The HTTP status code to check
 * @returns boolean indicating if the status code is in the 2xx range
 */
export const isSuccessStatus = (status: number): boolean => {
  return status >= 200 && status < 300
}

/**
 * Checks if an HTTP status code indicates a client error (4xx range)
 * @param status - The HTTP status code to check
 * @returns boolean indicating if the status code is in the 4xx range
 */
export const isClientErrorStatus = (status: number): boolean => {
  return status >= 400 && status < 500
}

/**
 * Checks if an HTTP status code indicates a server error (5xx range)
 * @param status - The HTTP status code to check
 * @returns boolean indicating if the status code is in the 5xx range
 */
export const isServerErrorStatus = (status: number): boolean => {
  return status >= 500 && status < 600
}
